import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const WalletCheck = (param)=>{
    let { size = 24, testId, style, className } = param;
    return /*#__PURE__*/ _jsx("svg", {
        width: size,
        height: size,
        "data-testid": testId,
        style: style,
        className: className,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M7.63 22.0001H17.74C19.81 22.0001 21.5 20.3101 21.5 18.2401V17.05H19.6C18.52 17.05 17.53 16.2601 17.44 15.1801C17.38 14.5501 17.62 13.96 18.04 13.55C18.41 13.17 18.92 12.9501 19.48 12.9501H21.5V11.5101C21.5 9.44007 19.81 7.75006 17.74 7.75006H6.25999C4.18999 7.75006 2.5 9.44007 2.5 11.5101V15.8801M7.63 22.0001C7.94 21.7401 8.21 21.4201 8.42 21.0601C8.79 20.4601 9 19.7501 9 19.0001C9 16.7901 7.21 15.0001 5 15.0001C4.06 15.0001 3.19 15.3301 2.5 15.8801M7.63 22.0001C6.93 22.6301 6.01 23.0001 5 23.0001C3.54 23.0001 2.27 22.2201 1.58 21.0601C1.21 20.4601 1 19.7501 1 19.0001C1 17.7401 1.58 16.6101 2.5 15.8801M2.5 12.4101V7.8401C2.5 6.6501 3.23 5.59006 4.34 5.17006L12.28 2.17006C13.52 1.70006 14.85 2.62009 14.85 3.95009V7.75008M7 12.0001H14M3.44141 18.9996L4.4314 19.9896L6.5614 18.0196M22.5588 13.9702V16.0303C22.5588 16.5803 22.1188 17.0302 21.5588 17.0502H19.5988C18.5188 17.0502 17.5288 16.2602 17.4388 15.1802C17.3788 14.5502 17.6188 13.9602 18.0388 13.5502C18.4088 13.1702 18.9188 12.9503 19.4788 12.9503H21.5588C22.1188 12.9703 22.5588 13.4202 22.5588 13.9702Z",
            stroke: "currentColor",
            strokeWidth: 1.5 * (24 / size),
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
